import { useUserStore } from 'src/stores/userStore';
function registerRoutesResolver() {
    return [
        {
            meta: {
                title: 'Elektroniczny dziennik',
                description: 'Dziennik parafialny - ewidencja obecności na nabożeństwach i katechezach osób przystępujących do I komunii św. i bierzmowania'
            },
            path: '/',
            component: () => import('layouts/register/MainLayout.vue'),
            children: [{ path: '', component: () => import('pages/Home/HomeReg.vue') }],
        },
        {
            meta: {
                title: 'Logowanie',
                description: 'Logowanie'
            },
            path: '/login',
            component: () => import('pages/Account/LoginReg.vue')
        },
        {
            meta: {
                title: 'Obecność kandydata do I Komunii na nabożeństwach',
                description: 'Obecność kandydata do I Komunii na nabożeństwach'
            },
            path: '/pierwsza-komunia',
            component: () => import('layouts/register/MainLayout.vue'),
            children: [{ path: '', component: () => import('pages/FirstHolyCommunionAttendance/FirstHolyCommunionAttendanceReg.vue') }],
            beforeEnter: async (to) => {
                return await navigationGuard(to, 'FirstCommunion');
            },
        },
        {
            meta: {
                title: 'Obecność kandydata do bierzmowania na nabożeństwach',
                description: 'Obecność kandydata do bierzmowania na nabożeństwach'
            },
            path: '/bierzmowanie',
            component: () => import('layouts/register/MainLayout.vue'),
            children: [{ path: '', component: () => import('pages/ConfirmationAttendance/ConfirmationAttendanceReg.vue') }],
            beforeEnter: async (to) => {
                return await navigationGuard(to, 'Confirmation');
            },
        },
        {
            meta: {
                title: 'Klauzula informacyjna',
                description: 'RODO - Klauzula informacyjna'
            },
            path: '/klauzula-informacyjna',
            component: () => import('layouts/register/MainLayout.vue'),
            children: [{ path: '', component: () => import('pages/GDPRInformationClause/GDPRInformationClause.vue') }],
        },
        {
            meta: {
                title: 'Polityka Cookies',
                description: 'Polityka cookies określająca zasady przechowywania i dostępu do danych na urządzeniach użytkowników'
            },
            path: '/polityka-cookies',
            component: () => import('layouts/register/MainLayout.vue'),
            children: [{ path: '', component: () => import('pages/CookiesPolicy/CookiesPolicyReg.vue') }],
        },
        {
            meta: {
                title: 'Błąd 403',
                description: 'Dostęp zabroniony'
            },
            path: '/forbidden',
            component: () => import('pages/Error403Reg.vue'),
        },
        {
            meta: {
                title: 'Błąd 404',
                description: 'Nie istniejąca strona'
            },
            path: '/:catchAll(.*)*',
            component: () => import('pages/Error404.vue'),
        },
    ];
}
async function navigationGuard(to, loginType) {
    const store = useUserStore();
    await store.loadUser();
    if (!store.isAuthenticated && to.path !== '/login') {
        store.setLoginType(loginType);
        store.setReturnUrl(to.path);
        return { path: '/login' };
    }
}
export default registerRoutesResolver;
